<template>
	<div
		class="container__model__preview"
		style="height: 100%; display: flex; flex-direction: column; justify-content: space-around"
	>
		<div>
			<div class="upper_preview">
				<div style="padding: 1rem">
					<InputSearch
						v-if="!$attrs.edit"
						v-model="searchText"
						:help="help"
						:placeholder="$t('typeAModelName')"
						@input="$emit('search', searchText)"
					/>
				</div>

				<div
					style="
						display: flex;
						justify-content: space-between;
						padding: 0 1rem;
						flex-direction: column;
						margin-top: 1.5rem;
						margin-bottom: 1.5rem;
					"
				>
					<div style="display: flex; justify-content: center">
						<!-- <input v-if="!$attrs.edit" style="margin: auto 0.5rem" type="radio" name="modelo"
              :checked="value === model.stan_nm_variavel_modelo" @click="handleClick($event.target.checked)"> -->
						<h1
							style="margin: 0; display: flex; justify-content: center; font-size: 1.5rem"
							class="model__name"
						>
							{{ model.stan_nm_titulo_modelo }}
						</h1>
					</div>

					<h1
						style="
							margin: 0;
							display: flex;
							justify-content: center;
							font-size: 0.9rem;
							padding: 0.3rem;
						"
						class="model__equacao"
					>
						{{ model.stan_nm_modelo }}
					</h1>
				</div>

				<div class="container__model_kpis">
					<KPI
						:value="
							model.stan_md_erro_porcentagem != null
								? model.stan_md_erro_porcentagem.toFixed(3)
								: '-'
						"
						:description="`% ${$t('error')}`"
					/>
					<KPI
						:value="model.stan_md_erro != null ? model.stan_md_erro.toFixed(3) : '-'"
						:description="$t('error')"
					/>
					<KPI
						:value="
							model.stan_md_coeficiente_assimetria != null
								? model.stan_md_coeficiente_assimetria.toFixed(3)
								: '-'
						"
						:description="$t('asymmetry')"
					/>
					<KPI
						:value="
							model.stan_md_coeficiente_curtose != null
								? model.stan_md_coeficiente_curtose.toFixed(3)
								: '-'
						"
						:description="$t('kurtosis')"
					/>
				</div>
			</div>
			<div
				v-if="Object.values(model).length"
				class="lower_preview"
			>
				<div
					class="container__image"
					style="display: flex; height: 100%; flex-direction: column"
				>
					<div class="top__image__chart">
						<center>
							<img :src="model.stan_jsonb_graficos[indexImage]?.blobLink" />
						</center>
					</div>
					<div style="display: flex; gap: 0.5rem; justify-content: center">
						<i
							v-for="(img, index) in model.stan_jsonb_graficos"
							:key="index"
							:style="`color: ${index === indexImage ? '#95bb49' : '#8b94a7'}; font-size: 0.6rem;, cursor: pointer;`"
							class="fas fa-circle"
							@click="indexImage = index"
						/>
					</div>
				</div>
			</div>
		</div>
		<slot />
	</div>
</template>

<script>
import InputSearch from '../InputSearch/InputSearch'
import KPI from '../KPI/KPI'

export default {
	components: {
		KPI,
		InputSearch,
		// Residuos, RealEstimado, Histogramas
	},
	inject: ['edit'],
	props: {
		model: {
			type: Object,
			required: true,
			default: () => {},
		},
		help: Object,

		// tipoInfoGrafico: {
		//   type: Object,
		//   required: true,
		// },

		value: {
			type: String,
			required: false,
		},
	},
	data() {
		return {
			searchText: '',
			indexImage: 0,
		}
	},
	methods: {
		handleClick(checked) {
			if (checked) this.$emit('input', this.model.stan_nm_variavel_modelo)
		},
	},
}
</script>

<style scoped>
.container__model_kpis {
	display: flex;
	flex-direction: row;
	justify-content: space-evenly;
	font-family: 'Open Sans', sans-serif;
}

.model__name,
.model__modelo {
	color: rgb(var(--color-primary));
	font-weight: 900;
}

.model__equacao {
	font-weight: 100;
	color: var(--color-gray);
}

.container__model__preview {
	height: 90%;
	display: flex;
	flex-direction: column;
	/* justify-content: space-between; */
	/* max-height: 60vh;
  margin-bottom: 10rem; */
}

.container__image {
	display: flex;
	flex-direction: row;
	/* height: 100%; */
	/* height: 100%; */
}

.lower_preview {
	/* height: 100%; */
	padding: 0.5rem 2rem;
}

@media screen and (min-device-width: 1200px) and (max-device-width: 1600px) and (-webkit-min-device-pixel-ratio: 1) {
	.container__model__preview {
		justify-content: none !important;
	}
}

@media screen and (max-width: 1370px) {
	.model__name,
	.model__modelo {
		color: #081f44;
		font-size: 18px;
		padding-bottom: 5px;
		padding-top: 5px;
		text-align: center;
	}

	.container__model_kpis {
		font-size: 0.2rem !important;
	}
}

img {
	/* height: 18rem; */
	height: auto;
	/* width: 60rem; */
	margin: 0 auto;
}

@media screen and (min-device-width: 1200px) and (max-device-width: 1600px) and (-webkit-min-device-pixel-ratio: 1) {
	img {
		width: 27rem;
	}
}

/* @media only screen and (max-width: 768px) {
  img {
    width: 27rem;
  }
} */

/* @media screen and (min-width: 992px) {
  img {
    width: 27rem;
  }
} */

.container__cardgrafico.main__parcels__chart {
	height: 100%;
}

.cor {
	color: black !important;
}
</style>
